var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49084",
    "data-name": "Path 49084",
    d: "M15.242.709,6.1,9.853A3.725,3.725,0,0,0,5,12.5v1.007a.75.75,0,0,0,.75.75H6.757a3.724,3.724,0,0,0,2.651-1.1l9.144-9.144a2.344,2.344,0,0,0,0-3.31A2.4,2.4,0,0,0,15.242.709Zm2.25,2.25L8.348,12.1a2.265,2.265,0,0,1-1.591.658H6.5V12.5a2.265,2.265,0,0,1,.658-1.591L16.3,1.769a.861.861,0,0,1,1.19,0,.842.842,0,0,1,0,1.189Z",
    transform: "translate(-1.25 -0.011)",
    fill: "#0464ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49085",
    "data-name": "Path 49085",
    d: "M17.25,6.734a.75.75,0,0,0-.75.75V11.25h-3a2.25,2.25,0,0,0-2.25,2.25v3H3.75A2.25,2.25,0,0,1,1.5,14.25V3.75A2.25,2.25,0,0,1,3.75,1.5h6.781a.75.75,0,1,0,0-1.5H3.75A3.754,3.754,0,0,0,0,3.75v10.5A3.754,3.754,0,0,0,3.75,18h8.507a3.726,3.726,0,0,0,2.652-1.1L16.9,14.908A3.726,3.726,0,0,0,18,12.257V7.484A.75.75,0,0,0,17.25,6.734Zm-3.4,9.107a2.231,2.231,0,0,1-1.1.6V13.5a.75.75,0,0,1,.75-.75h2.944a2.262,2.262,0,0,1-.6,1.1Z",
    transform: "translate(0 0)",
    fill: "#0464ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.19318a071c60867d104a5f575deeb1dc.svg";
export { ForwardRef as ReactComponent };